import moment from 'moment';
import LocalStorageHelper from './OldLocalStorageHelper';
import FetchHelper from './OldFetchHelper';

class NewsHelper {
  async getNewNewsPostsIDsAndCount() {
    let lastLogon = null;
    if(LocalStorageHelper.getPersonalInfo().lastLogon) {
      lastLogon = moment(LocalStorageHelper.getPersonalInfo().lastLogon.substr(0, 10)).format(`MM-DD-YYYY`);
    }

    const IDs = [];
    let newNews = 0;

    const fetchConfig = {
      baseURL: `/wp-json/ringana/v1`,
      path: `/newsNewRoute`,
    };

    const fetchResult = await FetchHelper.get(fetchConfig);

    if(!fetchResult.success) {
      throw new Error(fetchResult.message);
    }

    if(fetchResult.data !== null) {
      for(const data of fetchResult.data) {
        data.newsPostDate = moment(data.newsPostDate, `DD.MM.YYYY`).format(`MM-DD-YYYY`);
        if(moment(lastLogon).isBefore(data.newsPostDate)) {
          IDs.push(data.newsPostID);
          newNews++;
        }
      }
    }

    return {
      IDs,
      count: newNews,
    };
  }
}

export default new NewsHelper();
